import React, { type ReactNode } from "react";
import { GradientCard } from "ui/cards";
import Image, { type StaticImageData } from "next/image";
import { Box, type BoxProps } from "@chakra-ui/react";

type Props = BoxProps & {
  variant: React.ComponentProps<typeof GradientCard>["variant"];
  animationElement: ReactNode;
  mobileImage: StaticImageData;
  imageAlt: string;
  imageMinH?: BoxProps["minH"];
};

/**
 * A full-width card with a gradient background.
 * Used to display animations on larger viewports and a static image for mobile.
 */
export function FullWidthAnimationCard({ variant, animationElement, mobileImage, imageAlt, ...props }: Props) {
  return (
    <GradientCard
      variant={variant}
      startColorStop="-60%"
      endColorStop="140%"
      angle="230deg"
      display="flex"
      justifyContent="center"
      w="100%"
      maxW={{ base: "md", md: "100%" }}
      mt={20}
      py={{ base: 8, sm: 12, md: 16, lg: 28 }}
      px={{ base: 6, sm: 8, md: 12 }}
      {...props}
    >
      <Box boxSize="100%" display={{ base: "none", md: "flex" }} justifyContent="center">
        {animationElement}
      </Box>

      <Box boxSize="100%" display={{ base: "block", md: "none" }}>
        <Image src={mobileImage} alt={imageAlt} sizes="100%" style={{ objectFit: "contain" }} />
      </Box>
    </GradientCard>
  );
}
